<template>
	<Layout>
		<div class="l-container">
			<VideoCenter
				:context-filter="contextFilter"
				:event-filters="parsedAdditionalFilters"
				:sort-order="parsedSortOrder"
				:hide-filters="parsedAdditionalFilters !== null"
				:enable-filter-sport="$arenaConfig.enableSportsFilterInVideoCenter"
				:enable-filter-date="$arenaConfig.enableDateFilterInVideoCenter"
				:enable-filter-team-category="$arenaConfig.enableTeamCategoryFilterInVideoCenter"
				:enable-filter-team="$arenaConfig.enableTeamFilterInVideoCenter"
				:sports="sports"
				:content-period="contentPeriod"
				:team-categories="teamCategories"
				:teams="teams"
			/>
		</div>
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';
import VideoCenter from '@js/components/VideoCenter.vue';

export default {
	name:       'ViewVideoCenter',
	components: { Layout, VideoCenter },
	props:      {
		contextFilter: {
			type:     Object,
			required: true,
		},
		sports: {
			type:    Array,
			default: () => [],
		},
		contentPeriod: {
			type:    Array,
			default: () => [],
		},
		teamCategories: {
			type:    Array,
			default: () => [],
		},
		teams: {
			type:    Array,
			default: () => [],
		},
	},
	computed: {
		parsedAdditionalFilters() {
			return this.parseQueryParam('filters');
		},
		parsedSortOrder() {
			return this.parseQueryParam('sortOrder');
		},
	},
	methods: {
		parseQueryParam(param) {
			const params = new URLSearchParams(window.location.search);
			const qp = params.get(param);
			try {
				const parsed = typeof qp === 'string' ? JSON.parse(qp) : qp;
				if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
					return parsed;
				}
				return null;
			} catch (e) {
				return null;
			}
		},
	},
};
</script>

<style>

</style>
